const warned = new Set<string>();

/**
 * Logs a console.warn in development only, and only once per unique message.
 * Tree-shaken in production builds via the `process.env.NODE_ENV` guard.
 */
export function warnOnce(message: string): void {
  if (process.env.NODE_ENV === "production") {
    return;
  }

  if (!warned.has(message)) {
    warned.add(message);
    console.warn(message);
  }
}
